// Shared layout for the V2 page shell.
import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";

export const usePageShellStyles = createStyles({
  container: {
    width: "100%",
    height: "100%",
    overflow: "auto",
    padding: tokens.spacing[20],
    display: "flex",
    flexDirection: "column",
    color: tokens.color.semantic.text.bold,
    gap: tokens.spacing[6],
  },
  titleActions: {
    display: "flex",
    flexDirection: "row",
    gap: tokens.spacing[2],
  },
  // Heading + optional CTAs; pages toggle CTA placement here vs. the controls row via useMediaQuery.
  titleRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: tokens.spacing[4],
    flexWrap: "wrap",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: tokens.spacing[4],
    // Holds search + CTAs at their floor; the row scrolls horizontally once they no longer fit.
    minWidth: "min-content",
  },
  searchSlot: {
    flex: 1,
  },
  // Wraps controls + table in one scroll context so they shrink and scroll together at narrow widths.
  scrollStack: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacing[6],
    minWidth: "min-content",
  },
});
